if (!process.env.VITE) {
  const rc = require.context('./', false, /\.svg$/)

  rc.keys().map(rc)
}
